import { AppService } from './AppService';

export class UserService{
    appService = new AppService();
    //API_URL = 'http://localhost/sfrwebapp/api/'
    constructor(){
        //this.appService = 
        //const API_URL = 'http://localhost/sfrwebapp/api/'
    }

    getVadByUiid(uuid) {
        const url = this.appService.getApiUrl()+'user/user.php';
        const params = {
            uuid: uuid,
            action: 'getVadByUiid'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    
    authenticate() {
        const url = this.appService.getApiUrl()+'authenticate/token.php';
        const params = {
            client_id: this.appService.CLIENT_ID,
            client_api_key: this.appService.CLIENT_API_KEY
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    login(login, password,uuid) {
        const url = this.appService.getApiUrl()+'user/user.php';
        //const url = this.appService.getApiUrl()+'user/userphil.php';
        const params = {
            login: login,
            password: password,
            uuid:uuid,
            action: 'login'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                throw new Error(error);
                
            });
    }

    getUserFromAuthCode(authCode,uuid) {
        const url = this.appService.getApiUrl()+'user/userAzureAD.php';
        //const url = this.appService.getApiUrl()+'user/userphil.php';
        const params = {
            authCode: authCode,
            uuid:uuid,
            action: 'getUserFromAuthCode'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                throw new Error(error);
                
            });
    }

    addVadeur(tel, nom,prenom,site,codevendeur,uuid) {
        const url = this.appService.getApiUrl()+'user/user.php';
        //const url = "http://localhost/sfrwebapp/api/"+'user/user.php';
        const params = {
            tel: tel,
            nom: nom,
            prenom:prenom,
            site:site,
            codevendeur:codevendeur,
            uuid:uuid,
            action: 'add'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }
    updatePassword(pwdOld, pwdNew,pwdConf,idUser) {
        const url = this.appService.getApiUrl()+'user/user.php';
        //const url = "http://localhost/sfrwebapp/api/"+'user/user.php';
        const params = {
            pwdOld: pwdOld,
            pwdNew: pwdNew,
            pwdConf:pwdConf,
            idUser:idUser,
            action: 'changePassword'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    
    getListeVadeurs() {
        const url = this.appService.getApiUrl()+'user/user.php';
        //const url = "http://localhost/sfrwebapp/api/"+'user/user.php';
        const params = {
            action: 'getAll'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    deleteVadeur(idUser) {
        const url = this.appService.getApiUrl()+'user/user.php';
        //const url = "http://localhost/sfrwebapp/api/"+'user/user.php';
        const params = {
            idUser:idUser,
            action: 'delete'
        };
        return this.appService.post(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }



}